// extracted by mini-css-extract-plugin
export default {"container":"popover_wrapper-module__container--3bqu5"};